import { createAction, props } from '@ngrx/store';

import { Nutrient } from '../models';

export const loadNutrientsSuccess = createAction(
  '[App] load nutrients success',
  props<{ nutrients: Nutrient[] }>(),
);
